import { isNil } from 'lodash';
function currentUser({ currentUser }) {
  return currentUser;
}

export default {
  currentUser,
  isUserLoggedIn: state => !isNil(state.userProfile),
};
